// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem } from '@/components';
import { StyledBlockEnd } from '../Styled';
import { Button } from '@/ui';

// Modules
import FileUpload from '@/modules/Redirects/components/FileUpload/FileUpload';
import { ALLOWED_IMPORT_FILE_TYPES } from '@/modules/Redirects/helpers/constants';

// Helpers
import { TInterLinksImportFormValues, InterLinksImportFormFields } from '../../helpers/types';
import { useInterLinkFormRules } from '../../hooks';

type TImportLinksForm = {
  onSubmit: (values: TInterLinksImportFormValues) => void;
  isLoading?: boolean;
};

const ImportLinksForm = ({ onSubmit, isLoading }: TImportLinksForm) => {
  const rules = useInterLinkFormRules();
  const { t } = useTranslation(['common']);

  return (
    <Form onFinish={onSubmit}>
      <FormItem
        name={InterLinksImportFormFields.FILE}
        label={t('label_import_file')}
        rules={rules[InterLinksImportFormFields.FILE]}
      >
        <FileUpload accept={ALLOWED_IMPORT_FILE_TYPES} />
      </FormItem>
      <StyledBlockEnd>
        <Button type="default" htmlType="submit" loading={isLoading}>
          {t('btn_redirects_import_start')}
        </Button>
      </StyledBlockEnd>
    </Form>
  );
};

export default ImportLinksForm;
